import { WixSDK } from '../wix-sdk';
import { FedopsLoggerWrapper } from './loggerWrapper';
import { InteractionsState } from './interactions-state';
export class Logger extends FedopsLoggerWrapper {
  constructor(panorama) {
    const compId = WixSDK.Utils.getOrigCompId() || WixSDK.Utils.getCompId();
    const pubSub = WixSDK.PubSub;
    const interactionsState = new InteractionsState({
      compId,
      pubSub
    });
    super({
      panorama,
      interactionsState
    });
  }
}
//# sourceMappingURL=logger.js.map